export const customColors = {
  Base: {
    BaseWhite: 'var(--base-white)',
    BaseBlack: 'var(--base-black)',
  },
  Primary: {
    Cypress5: 'var(--primary-cypress-5)',
    Cypress10: 'var(--primary-cypress-10)',
    Cypress15: 'var(--primary-cypress-15)',
    Cypress25: 'var(--primary-cypress-25)',
    Cypress50: 'var(--primary-cypress-50)',
    Cypress75: 'var(--primary-cypress-75)',
    Cypress100: 'var(--primary-cypress-100)',
    Cypress125: 'var(--primary-cypress-125)',
    Cypress150: 'var(--primary-cypress-150)',
    Cypress175: 'var(--primary-cypress-175)',
    Cypress200: 'var(--primary-cypress-200)',
  },
  SecondarySpearmint: {
    Spearmint5: 'var(--secondary-spearmint-5)',
    Spearmint10: 'var(--secondary-spearmint-10)',
    Spearmint15: 'var(--secondary-spearmint-15)',
    Spearmint25: 'var(--secondary-spearmint-25)',
    Spearmint50: 'var(--secondary-spearmint-50)',
    Spearmint75: 'var(--secondary-spearmint-75)',
    Spearmint100: 'var(--secondary-spearmint-100)',
  },
  SecondaryOcean: {
    Ocean5: 'var(--secondary-ocean-5)',
    Ocean10: 'var(--secondary-ocean-10)',
    Ocean15: 'var(--secondary-ocean-15)',
    Ocean25: 'var(--secondary-ocean-25)',
    Ocean50: 'var(--secondary-ocean-50)',
    Ocean75: 'var(--secondary-ocean-75)',
    Ocean100: 'var(--secondary-ocean-100)',
  },
  SecondarySalamander: {
    Salamander5: 'var(--secondary-salamander-5)',
    Salamander10: 'var(--secondary-salamander-10)',
    Salamander15: 'var(--secondary-salamander-15)',
    Salamander25: 'var(--secondary-salamander-25)',
    Salamander50: 'var(--secondary-salamander-50)',
    Salamander75: 'var(--secondary-salamander-75)',
    Salamander100: 'var(--secondary-salamander-100)',
  },
  NeutralsNight: {
    Night5: 'var(--neutrals-night-5)',
    Night10: 'var(--neutrals-night-10)',
    Night20: 'var(--neutrals-night-20)',
    Night40: 'var(--neutrals-night-40)',
    Night60: 'var(--neutrals-night-60)',
    Night80: 'var(--neutrals-night-80)',
    Night100: 'var(--neutrals-night-100)',
  },
  NeutralsTruffle: {
    Truffle5: 'var(--neutrals-truffle-5)',
    Truffle10: 'var(--neutrals-truffle-10)',
    Truffle15: 'var(--neutrals-truffle-15)',
    Truffle25: 'var(--neutrals-truffle-25)',
    Truffle50: 'var(--neutrals-truffle-50)',
    Truffle75: 'var(--neutrals-truffle-75)',
    Truffle100: 'var(--neutrals-truffle-100)',
  },
  DecorativePeachy: {
    Peachy5: 'var(--decorative-peachy-5)',
    Peachy10: 'var(--decorative-peachy-10)',
    Peachy15: 'var(--decorative-peachy-15)',
    Peachy25: 'var(--decorative-peachy-25)',
    Peachy50: 'var(--decorative-peachy-50)',
    Peachy75: 'var(--decorative-peachy-75)',
    Peachy100: 'var(--decorative-peachy-100)',
  },
  DecorativeLime: {
    Lime5: 'var(--decorative-lime-5)',
    Lime25: 'var(--decorative-lime-25)',
    Lime50: 'var(--decorative-lime-50)',
    Lime100: 'var(--decorative-lime-100)',
  },
  UtilityCarmineRed: {
    CarmineRed5: 'var(--utility-carmine-red-5)',
    CarmineRed25: 'var(--utility-carmine-red-25)',
    CarmineRed50: 'var(--utility-carmine-red-50)',
    CarmineRed75: 'var(--utility-carmine-red-75)',
    CarmineRed100: 'var(--utility-carmine-red-100)',
  },
  UtilityRoyalOrange: {
    RoyalOrange5: 'var(--utility-royal-orange-5)',
    RoyalOrange25: 'var(--utility-royal-orange-25)',
    RoyalOrange50: 'var(--utility-royal-orange-50)',
    RoyalOrange75: 'var(--utility-royal-orange-75)',
    RoyalOrange100: 'var(--utility-royal-orange-100)',
    RoyalOrange125: 'var(--utility-royal-orange-125)',
    RoyalOrange150: 'var(--utility-royal-orange-150)',
    RoyalOrange175: 'var(--utility-royal-orange-175)',
    RoyalOrange200: 'var(--utility-royal-orange-200)',
  },
  UtilitySuccessCypress: {
    SuccessCypress5: 'var(--utility-success-cypress-5)',
    SuccessCypress15: 'var(--utility-success-cypress-15)',
    SuccessCypress20: 'var(--utility-success-cypress-20)',
    SuccessCypress25: 'var(--utility-success-cypress-25)',
    SuccessCypress50: 'var(--utility-success-cypress-50)',
    SuccessCypress75: 'var(--utility-success-cypress-75)',
    SuccessCypress100: 'var(--utility-success-cypress-100)',
    SuccessCypress125: 'var(--utility-success-cypress-125)',
    SuccessCypress150: 'var(--utility-success-cypress-150)',
    SuccessCypress175: 'var(--utility-success-cypress-175)',
    SuccessCypress200: 'var(--utility-success-cypress-200)',
  },
  UtilityInfoOcean: {
    InfoOcean5: 'var(--utility-info-ocean-5)',
    InfoOcean15: 'var(--utility-info-ocean-15)',
    InfoOcean20: 'var(--utility-info-ocean-20)',
    InfoOcean25: 'var(--utility-info-ocean-25)',
    InfoOcean50: 'var(--utility-info-ocean-50)',
    InfoOcean75: 'var(--utility-info-ocean-75)',
    InfoOcean100: 'var(--utility-info-ocean-100)',
    InfoOcean125: 'var(--utility-info-ocean-125)',
    InfoOcean150: 'var(--utility-info-ocean-150)',
    InfoOcean175: 'var(--utility-info-ocean-175)',
    InfoOcean200: 'var(--utility-info-ocean-200)',
  },
  UtilityWarningRoyalOrange: {
    WarningRoyalOrange5: 'var(--utility-warning-royal-orange-5)',
    WarningRoyalOrange15: 'var(--utility-warning-royal-orange-15)',
    WarningRoyalOrange20: 'var(--utility-warning-royal-orange-20)',
    WarningRoyalOrange25: 'var(--utility-warning-royal-orange-25)',
    WarningRoyalOrange50: 'var(--utility-warning-royal-orange-50)',
    WarningRoyalOrange75: 'var(--utility-warning-royal-orange-75)',
    WarningRoyalOrange100: 'var(--utility-warning-royal-orange-100)',
    WarningRoyalOrange125: 'var(--utility-warning-royal-orange-125)',
    WarningRoyalOrange150: 'var(--utility-warning-royal-orange-150)',
    WarningRoyalOrange175: 'var(--utility-warning-royal-orange-175)',
    WarningRoyalOrange200: 'var(--utility-warning-royal-orange-200)',
  },
  UtilityErrorCarmineRed: {
    ErrorCarmineRed5: 'var(--utility-error-carmine-red-5)',
    ErrorCarmineRed15: 'var(--utility-error-carmine-red-15)',
    ErrorCarmineRed20: 'var(--utility-error-carmine-red-20)',
    ErrorCarmineRed25: 'var(--utility-error-carmine-red-25)',
    ErrorCarmineRed50: 'var(--utility-error-carmine-red-50)',
    ErrorCarmineRed75: 'var(--utility-error-carmine-red-75)',
    ErrorCarmineRed100: 'var(--utility-error-carmine-red-100)',
    ErrorCarmineRed125: 'var(--utility-error-carmine-red-125)',
    ErrorCarmineRed150: 'var(--utility-error-carmine-red-150)',
    ErrorCarmineRed175: 'var(--utility-error-carmine-red-175)',
    ErrorCarmineRed200: 'var(--utility-error-carmine-red-200)',
  },
} as const;

export type CSSVariablesType = typeof customColors;
